import { normalizeLocale, type SupportedLocale } from './config';

const COPY = {
  en: {
    recovery: 'Your workspace connection could not be confirmed.',
    retry: 'Reload and try again',
  },
  ar: {
    recovery: 'تعذر تأكيد الاتصال بمساحة عملك.',
    retry: 'أعد التحميل وحاول مجددًا',
  },
  es: {
    recovery: 'No se pudo confirmar la conexión con tu espacio de trabajo.',
    retry: 'Recargar e intentar de nuevo',
  },
  'pt-BR': {
    recovery:
      'Não foi possível confirmar a conexão com seu espaço de trabalho.',
    retry: 'Recarregar e tentar novamente',
  },
  fr: {
    recovery:
      'La connexion à votre espace de travail n’a pas pu être confirmée.',
    retry: 'Recharger et réessayer',
  },
  it: {
    recovery: 'Impossibile confermare la connessione al tuo spazio di lavoro.',
    retry: 'Ricarica e riprova',
  },
  ko: {
    recovery: '워크스페이스 연결을 확인할 수 없습니다.',
    retry: '새로고침하고 다시 시도',
  },
  de: {
    recovery:
      'Die Verbindung zum Arbeitsbereich konnte nicht bestätigt werden.',
    retry: 'Neu laden und erneut versuchen',
  },
  ja: {
    recovery: 'ワークスペースへの接続を確認できませんでした。',
    retry: '再読み込みして再試行',
  },
  hi: {
    recovery: 'आपके कार्यक्षेत्र का कनेक्शन सत्यापित नहीं हो सका।',
    retry: 'फिर से लोड करें और प्रयास करें',
  },
  ru: {
    recovery: 'Не удалось подтвердить подключение к рабочему пространству.',
    retry: 'Перезагрузить и повторить',
  },
  zh: {
    recovery: '无法确认工作区连接。',
    retry: '重新加载并重试',
  },
  'zh-TW': {
    recovery: '無法確認工作區連線。',
    retry: '重新載入並重試',
  },
  vi: {
    recovery: 'Không thể xác nhận kết nối với không gian làm việc.',
    retry: 'Tải lại và thử lại',
  },
  id: {
    recovery: 'Koneksi ruang kerja tidak dapat dikonfirmasi.',
    retry: 'Muat ulang dan coba lagi',
  },
} satisfies Record<SupportedLocale, { recovery: string; retry: string }>;

export function getProtectedWorkspaceCopy(locale: string) {
  return COPY[normalizeLocale(locale)];
}
